<template>
  <div class="pages">
    <div class="login">
      <van-loading type="spinner"/>
    </div>
  </div>
</template>

<script>
  import {Loading, Toast} from 'vant';
  import {getUrlKey, getIntoUrl} from '../assets/js/commonFn.js';

  export default {
    data() {
      return {
        routerUrl: "",  // APP路由从哪来
        weixinUrl: '',  // 微信路由
        weixinOpenid: ''  // 记录openid
      }
    },
    created() {
      // 获取token的方法
      this.getTokenFn();
    },
    components: {
      [Loading.name]: Loading,
      [Toast.name]: Toast,
    },
    methods: {
      // 获取token的方法
      getTokenFn() {
        let token = window.localStorage.getItem('tokenH');
        let tokenBe = this.$store.state.tokenBe;

        let shareSnBtn = false;
        let share_sn = '';
        let url = window.localStorage.getItem("fromPath");
        let weixinUrl = getIntoUrl(url);
        if (url) {
          let account_sn = getUrlKey("account_sn", url);

          if (account_sn) {
            share_sn = account_sn;
            shareSnBtn = true;
          } else {
            share_sn = '';
          }
        }

        if (!token || tokenBe == '1') {
          this.sendHttp({
            method: 'post',
            url: `${this.accountUrl}/api/accesstoken`,
            data: {
              share_sn,
            },
          }).then(res => {
            if (res.code == '0') {
              let tokenStr = res.data.token;
              // 把获取到的存到本地缓存
              window.localStorage.setItem('tokenH', tokenStr);

              // 登录
              this.loginFn();
            }
          })
        }else{
          this.$router.push('/')
        }
      },

      // 登录
      loginFn() {
        // 先判断是APP 还是微信 环境
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          let url = window.localStorage.getItem("fromPath");
          this.weixinOpenid = window.localStorage.getItem("setWapWeixinOpenid");

          // 判断是否需要去拿openid
          if (this.weixinOpenid) {
            this.wapWeixinLogin(this.weixinOpenid);
          } else {
            //window.location.href = `${this.$urlPay}?url=${this.$urlLogin}`;
            // window.location.href = `${this.$urlPay}?url=http://localhost:8080/login`;
            window.location.href = `${this.$urlPay}?url=${this.$baseUrl}/login`;
          }
        } else {
          this.getAppToken();
        }
      },

      // 获取ios token
      getAppToken() {
        this.$bridge.callhandler('getToken', {}, (data) => {
          let iosToken = data.token;
          if (iosToken) {
            window.localStorage.setItem('APPStorageToken', iosToken);
            this.syncLogin(iosToken);
          } else {
            this.$router.push('/');
          }
        });

        if (window.hasOwnProperty('Android')) {
          let AndroidToken = window.Android.getToken();
          if (AndroidToken) {
            window.localStorage.setItem('APPStorageToken', AndroidToken);
            this.syncLogin(AndroidToken);
          } else {
            this.$router.push('/')
          }
        }

        // this.syncLogin('6436eb8e5bdf43f9974b9bc5f243b9c1');

        // 正式环境我的token
        //this.syncLogin('52ee31ec92fc4fe58d2eae777d3d2915');
      },

      // APP做同步登陆
      syncLogin(token) {
        this.sendHttp({
          method: 'post',
          url: `${this.accountUrl}/partnerlogin/synclogin`,
          data: {
            sync_token: token,
          }
        }).then(res => {
          if (res.code == '0') {
            //保存当前角色类型
            window.localStorage.setItem('partner_type',res.data.partner_type);
            let url = window.localStorage.getItem("fromPath");
            let APPurl = '';
            APPurl = this.routerUrl;
            // let weixinUrl = getIntoUrl(url);
            // if (this.routerUrl == '/') {
            //   APPurl = weixinUrl
            // } else {
            //   APPurl = this.routerUrl;
            // }

            this.$router.push({
              path: APPurl,
            })
          }else if(res.code=='120'){
            this.$router.push('/webLogin');
          } else {
            Toast({
              message: `${res.msg}`,
              duration: 2000,
            })
            this.$router.push({
              path: '/'
            })
          }
        })
      },

      // 微信公众号wap登录
      wapWeixinLogin(openid) {
        let url = window.localStorage.getItem("fromPath");
        this.weixinUrl = getIntoUrl(url);

        let cat_id = getUrlKey("cat_id", url);
        let id = getUrlKey("id", url);
        let kyw = getUrlKey("kyw", url);
        let relation = getUrlKey("relation", url);
        let account_sn = getUrlKey("account_sn", url);

        this.sendHttp({
          method: 'POST',
          url: `${this.accountUrl}/partnerlogin/openidlogin`,
          data: {
            openid,
          }
        }).then(res => {
          console.log(res)
          if (res.code == '0') {
            window.localStorage.setItem('partner_type',res.data.partner_type);
            let pathUrl = '';
            if (this.routerUrl == '/') {
              pathUrl = `/${this.weixinUrl}`;
            } else {
              pathUrl = this.routerUrl;
            }

            this.$router.push({
              path: pathUrl,
              query: {
                cat_id,
                id,
                kyw,
                relation,
                account_sn,
              }
            });
          } else if (res.code == '120') {
            this.$router.push({
              path: '/webLogin',
            })
          } else {
            Toast({
              message: `${res.msg}`,
              duration: 2000,
            })
            this.$router.push({
              path: '/'
            })

          }
        })
      },

    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.routerUrl = from.path;
      })
    },
  }

</script>

<style scoped lang="less">
  .login {
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
